import { p as proxyCustomElement, H, h, F as Fragment, a as Host } from './index.js';

const dividerCss = ":host{align-items:center;display:flex;justify-content:center}.line{background-color:var(--jw-theme-surface-divider-color);flex:1;height:1px;width:100%}.or-text{background-color:var(--jw-theme-surface-tile-bg-color);color:var(--jw-theme-surface-text-description-color);font-family:Open Sans;font-size:.75rem;font-weight:700;letter-spacing:.03em;line-height:1rem;padding:.25rem .75rem;text-transform:uppercase}:host([type=vertical]){min-height:100%;width:1px}:host([type=vertical]) .line{height:100%;max-height:100%;min-height:1.5rem;width:100%}";

const WuiDivider = /*@__PURE__*/ proxyCustomElement(class WuiDivider extends H {
    constructor(registerHost) {
        super();
        if (registerHost !== false) {
            this.__registerHost();
        }
        this.__attachShadow();
        /**
         * Type
         */
        this.type = 'horizontal';
    }
    render() {
        return (h(Host, { key: 'e4b37871c445ce6c25213fb74554b720f3c4e05d' }, h("div", { key: 'ac3b3651f41799cc67d2eb38125a272f19c033c7', class: "line" }), this.type === 'horizontal-or' && (h(Fragment, { key: '3b58b521c77dfeaf429b07e8f8d844f7bdf7f616' }, h("div", { key: '6e2d32f183f47f17ec9b3cf2b8d0f921ee327e57', class: "or-text" }, "OR"), h("div", { key: '8fe5c1beeef138a02ca171556c9fa5507e4164da', class: "line" })))));
    }
    static get style() { return dividerCss; }
}, [257, "wui-divider", {
        "type": [513]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-divider"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-divider":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiDivider);
            }
            break;
    } });
}
defineCustomElement();

export { WuiDivider as W, defineCustomElement as d };
